module.exports = {
  FACTORY: "0x9dA8f3667e9424eb570E9f4bF6Efd977989be793",
  ASSETS: {
    ETH: "0x0000000000000000000000000000000000000000",
    DAI: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    WETH: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    USDC: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    USDT: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    SUSD: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
    WBTC: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
    REP: "0x1985365e9f78359a9B6AD760e32412f4a445E862",
    CDAI: "0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643",
    CUSDC: "0x39AA39c021dfbaE8faC545936693aC917d5E7563",
    CWBTC: "0xC11b1268C1A384e55C48c2391d8d480264A3A7F4",
    CETH: "0x4Ddc2D193948926D02f9B1fE9e1daa0718270ED5",
  },
  OPERATIONS: {
    INPUT: "0x0000000000000000000000000000000000000001",
    SPLITTER: "0x0000000000000000000000000000000000000002",
    OP_WRAP_ETH: "0x4958645527963B3Fc71F616De6447AD6d95E2DB0",
    OP_0X: "0x1c1eCF4C3e9761A167c74f8b21E533fB285506a8",
    OP_COMPOUND: "0xa35843F62494198bDdAc47e3eec0139747C9a38D",
    OP_UNISWAP: "0xD6Aa4D1D0D89056aB1876C87651d55E894Ff2898",
    OP_CURVE: "0xB7EC15E16795Cba4c28543179C0ae34C4fD11d8C",
    OP_OASIS: "0xFC8bC882F2A5119F6770f3BaE66d17413bB980d8",
    OP_UNISWAP_V2: "0x29693A064C17B124d95998a7b60DA18461611C16",
  },
  UNISWAP: {
    UNISWAP_EXCHANGE_DAI_ETH: "0x2a1530C4C41db0B0b2bB646CB5Eb1A67b7158667",
    UNISWAP_EXCHANGE_USDC_ETH: "0x97deC872013f6B5fB443861090ad931542878126",
    UNISWAP_EXCHANGE_WBTC_ETH: "0x4d2f5cFbA55AE412221182D8475bC85799A5644b",
  },
  UNISWAPV2: {
    UNISWAP_EXCHANGE_DAI_WETH: "0xA478c2975Ab1Ea89e8196811F51A7B7Ade33eB11",
    UNISWAP_EXCHANGE_USDC_WETH: "0xB4e16d0168e52d35CaCD2c6185b44281Ec28C9Dc",
    UNISWAP_EXCHANGE_WBTC_WETH: "0xBb2b8038a1640196FbE3e38816F3e67Cba72D940",
  },
  CURVE: {
    CURVE_POOL_DAI_USDC_USDT_SUSD: {
      address: "0xA5407eAE9Ba41422680e2e00537571bcC53efBfD",
      indexes: ["DAI", "USDC", "USDT", "SUSD"],
    },
  },
  OASIS: {
    OASIS_MATCHING_MARKET: "0x794e6e91555438aFc3ccF1c5076A74F42133d08D",
  },
  OPERATION_EXECUTOR: "0x54758e80Ae7d327627E5Cf072C798E8D64C62f8b",
};
